import React from 'react';
export function Footer() {
  return <footer className="defer-paint w-full border-t border-zinc-800 bg-zinc-950 py-10" data-id="element-79" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-80" data-mp="3gg118925080a">
        <p className="font-serif text-base font-bold uppercase tracking-[0.3em] text-stone-100" data-id="element-81" data-mp="32o4ao9g4a660">
          Atletica <span className="text-yellow-500" data-id="element-82" data-mp="36oxzd51dvozy">360</span>
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-yellow-500/50" aria-hidden="true" data-id="element-83" data-mp="36nd6rkymqg4q" />
        <p className="mt-6 font-sans text-xs leading-relaxed text-stone-400" data-id="element-84" data-mp="3uftlpmn2lrzt">
          © 2026 Atletica 360 — Tutti i diritti riservati.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-sans text-[11px] leading-relaxed text-stone-400" data-id="element-85" data-mp="3levih6kghoia">
          Sistema digitale di allenamento per allenatori di atletica leggera. I
          risultati dipendono da come il sistema viene applicato negli
          allenamenti reali.
        </p>
      </div>
    </footer>;
}